(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athar-shop-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  function highlight(root, id) {
    root.querySelectorAll('[data-athar-card]').forEach(function (c) { c.classList.toggle('is-active', c.dataset.atharCard === id); });
    root.querySelectorAll('[data-athar-dot]').forEach(function (d) { d.classList.toggle('is-active', d.dataset.atharDot === id); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var dot = e.target.closest('[data-athar-dot]');
    if (dot) {
      var root = dot.closest('[data-athar-look]');
      var id = dot.dataset.atharDot;
      var card = root.querySelector('[data-athar-card="' + id + '"]');
      if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      highlight(root, id);
      return;
    }

    var arrow = e.target.closest('[data-athar-prev], [data-athar-next]');
    if (!arrow) return;
    var section = arrow.closest('[data-athar-look]');
    var t = section && section.querySelector('[data-athar-track]');
    if (!t) return;
    var first = t.querySelector('.athar-look__card');
    var step = first ? first.getBoundingClientRect().width + 16 : t.clientWidth * 0.88;
    var dir = arrow.hasAttribute('data-athar-next') ? 1 : -1;
    if (getComputedStyle(t).direction === 'rtl') dir = -dir;
    t.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.closest && el.closest('[data-athar-look]')) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
